import request from '@/utils/request'

export function index(params) {
    return request({
        url: 'visitors/guest_companies',
        method: 'get',
        params: params
    })
}

export function inventory(params) {
    return request({
        url: 'visitors/guest_company/inventory',
        method: 'get',
        params: params
    })
}

export function show(id) {
    return request({
        url: `/visitors/guest_companies/${id}`,
        method: 'get'
    })
}

export function store(data) {
    return request({
        url: `visitors/guest_companies`,
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: `visitors/guest_companies/${data.id}`,
        method: 'put',
        data
    })
}

export function destroy(data) {
    return request({
        url: `visitors/guest_companies/${data.id}`,
        method: 'delete',
    })
}
